import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './Radio.module.scss';

export const Radio = props => {
  const {
    className,
    radioClassName,
    name='radio',
    label,
    id,
    labelTpl = <span>{label}</span>,
    disabled = false,
    ...other
  } = props;

  return (
    <div className={clsx(styles.radio, className)} >
      <input type="radio" name={name} id={id} className={styles.radioInput} disabled={disabled} {...other} />
      <label htmlFor={id} className={clsx(styles.radioLabel, radioClassName, { [styles.radioLabelDisabled]: disabled })}>{labelTpl}</label>
    </div>
  )
};

Radio.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  radioClassName: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Radio;
